module.exports = __webpack_public_path__ + "img/@logo_kif.5407a850.png";